type RefreshTokenParams = {
    tokenEndpoint: string;
    clientId: string;
    refreshToken: string;
};

type RefreshTokenResponse = {
    access_token?: string;
    refresh_token?: string;
};

type RefreshResult = {
    ok: boolean;
    status: number;
    data: RefreshTokenResponse;
};

export const refreshToken = async ({
    tokenEndpoint,
    clientId,
    refreshToken,
}: RefreshTokenParams): Promise<RefreshResult> => {
    const params = new URLSearchParams();
    params.append('grant_type', 'refresh_token');
    params.append('client_id', clientId);
    params.append('refresh_token', refreshToken);

    const response = await fetch(tokenEndpoint, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params.toString(),
    });

    const data: RefreshTokenResponse = await response.json();

    return {
        ok: response.ok,
        status: response.status,
        data,
    };
};

export type { RefreshTokenResponse };
